import React from 'react';
import { Paper, Typography, Button, Box, IconButton, useTheme, Zoom } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SyncIcon from '@mui/icons-material/Sync';

const ContextSyncAlert = ({ 
    count, 
    onReplaceAll, 
    onViewMatches, 
    onIgnore,
    isVisible 
}) => {
    const theme = useTheme();

    if (!isVisible) return null;

    return (
        <Zoom in={isVisible}>
            <Paper
                elevation={6}
                sx={{
                    position: 'fixed',
                    bottom: 24,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 2000,
                    p: 2,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 3,
                    borderRadius: '16px',
                    border: '1px solid',
                    borderColor: 'primary.main',
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(8px)',
                    minWidth: 400,
                    maxWidth: '90vw'
                }}
            >
                <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    backgroundColor: 'primary.lighter',
                    color: 'primary.main'
                }}>
                    <SyncIcon />
                </Box>

                <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="subtitle2" fontWeight={700}>
                        Smart Replace
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        This text appears in {count} other segment{count !== 1 ? 's' : ''}.
                    </Typography>
                </Box>

                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button 
                        size="small" 
                        variant="contained" 
                        color="primary" 
                        onClick={onReplaceAll}
                        sx={{ textTransform: 'none', borderRadius: '8px' }}
                    >
                        Replace All
                    </Button>
                    <Button 
                        size="small" 
                        variant="outlined" 
                        onClick={onViewMatches}
                        sx={{ textTransform: 'none', borderRadius: '8px' }}
                    >
                        View Matches
                    </Button>
                    <IconButton size="small" onClick={onIgnore} sx={{ ml: 1 }}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </Box>
            </Paper>
        </Zoom>
    );
};

export default ContextSyncAlert;
